import React, { useState } from 'react';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import AddSuggestedProductToCartButton from '../Utils/SuggestedProductAddToCartButton';
import SuggestedProductCardImage from '../Utils/SuggestedProductCardImage';
import SuggestProductCardPrice from '../Utils/SuggestProductCardPrice';
import { SUGGESTED_PRODUCT_SECTION } from '../../../constants';
import { SuggestedProductCardRow } from '../Styles/SuggestedProductCard.styling';
import { SuggestedProduct } from '../../../Types/SuggestedProduct';

interface SuggestedRowProductCardProps {
  product: SuggestedProduct;
  className?: string;
}
const SuggestedProductCard = ({
  product,
  className = '',
}: SuggestedRowProductCardProps) => {
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );
  const [email] = useState<string | any>(userInfo?.email)

  return (
    <SuggestedProductCardRow className={className}>
      <SuggestedProductCardImage product={product} className={"image-wrapper"} />
      <div className="right-section justify-between">
        <div className="top-section">
          <div className="content gap-[8px]">
            <div className="font-satoshi-bold">
              <a href={product.url}>{product.name}</a>
            </div>
            <div className="description">
              <span className="name-description">
                {product.productCardDescription}
              </span>
            </div>
          </div>
        </div>
        <div className="footer">
          <AddSuggestedProductToCartButton
            articleNumber={product.id}
            brandTrackingSource={product.brandTrackingSource}
            email={email}
            btnSize="xsmall"
            usedIn={SUGGESTED_PRODUCT_SECTION.Minicart}
          />
          <SuggestProductCardPrice className='self-end' product={product}></SuggestProductCardPrice>
        </div>
      </div>
    </SuggestedProductCardRow>
  );
};

export default SuggestedProductCard;